import * as confirmAction from "../../../../store/confirm/action";
import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
  AUTO_CAL_BALANCE_SHRINKAGE,
  GET_DT_BALANCE_ENERGY,
  GET_DT_BALANCE_ZONE_ENERGY,
  GET_SHIPPER_BY_BOOKING,
  SAVE_DT_BALANCE_ENERGY,
  SAVE_DT_BALANCE_ZONE_ENERGY,
} from "helpers/url_api_constant";
import { Col, Modal, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { Tab } from "bootstrap";
import TableEnergy from "./TableEnergy";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function BalancingEnergy(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);

  const [balanceShipper, setBalanceShipper] = useState([]);
  const [mergeData, setMergeData] = useState([]);
  const [dateSelect, setDateSelect] = useState(
    moment().add("days", -1).toDate()
  );
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "SHIPPER_NAME",
      text: "",
      headerAlign: "center",

      align: "center",
      headerStyle: {
        backgroundColor: "#556ee6",
        fontSize: "12px",
        width: "40px",
      },
      style: { width: "40px" },
    },
  ]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const addHeaderTable = () => {
    $(`.balancingenergy-table-header`).remove();

    let thead = document
      .getElementById(`balancingenergy-table`)
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML = `<th class="balancingenergy-table-header" colspan="1" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px;width:40px" ,">Shipper</th>`;
    props.column.map(row => {
      tr.innerHTML += `<th class="balancingenergy-table-header" colspan="${props.zone.length}" style="text-align:center;background-color:#556ee6;color:#FFFFFF;font-size:12px">${row.BALANCECOLUMN_NAME}</th>`;
    });

    thead.prepend(tr);
  };

  const ButtonAction = (cellContent, row) => {
    return (
      <div>
        {permission.eBSG && (
          <>
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={() => {}}
            >
              Refresh
            </button>
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={() => {
                handleSaveDataByRow(row);
              }}
            >
              Save
            </button>
          </>
        )}
      </div>
    );
  };

  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];

      // console.log(modelDeviceList)
      modelDeviceList.map(obj => {
        props.column.map(objColumn => {
          props.zone.map(objZone => {
            data.push({
              ...obj[
                `data_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                  ".",
                  "_"
                )
              ],
              BALANCE_DATA:
                obj[
                  `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                    ".",
                    "_"
                  )
                ],
            });
          });
        });
      });
      // console.log(data)

      let res = await post(SAVE_DT_BALANCE_ZONE_ENERGY, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        generateRow();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const handleSaveDataByRow = async row => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      console.log(row);
      columnDataList.map(objColumn => {
        data.push({
          ...row[`${objColumn.BALANCECOLUMN_NAME.replaceAll(".", "_")}__data`],
          BALANCE_DATA: row[objColumn.BALANCECOLUMN_NAME.replaceAll(".", "_")],
        });
      });
      //   console.log(row);
      let res = await post(SAVE_DT_BALANCE_ENERGY, data);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Save success."));
        // fetchData()
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const getBalanceShipperData = async () => {
    let shipper = await getBalanceShipper();
    let shipperList = [];
    shipper = shipper.data.shipperDataList;
    // console.log(shipper,sysShipper)
    shipper.map(row => {
      // console.log(row.SHIPPER_CODE)
      let mapShipper = props.shipper.find(
        obj =>
          obj.SHIPPER_NAME.trim().toLowerCase() ==
            row.SHOW_BOOING_VALUE.trim().toLowerCase() ||
          obj.CONTACT_CODE.trim().toLowerCase() ==
            row.SHIPPER_CODE.trim().toLowerCase()
      );
      if (mapShipper) shipperList.push(mapShipper);
    });
    setBalanceShipper(shipperList);
  };

  const manualRefresh = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(AUTO_CAL_BALANCE_SHRINKAGE, {
        // BALANCE_DATE: "01-01",
        BALANCE_DATE: moment(dateSelect).format("YYYY-MM-DD"),
        LOAD_DATA_TYPE: 0,
      });
      // console.log(res);
      if (res.resultCode == 200) {
        dispatch(messageAction.showMessage("Refresh Success"));
        generateRow();
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const generateRow = async () => {
    // console.log('test')
    dispatch(loadingAction.showLoading());
    try {
      let [BALANCE_ENERGY, BALANCE_ZONE_ENERGY, BALANCE_ENERGY_ALL] =
        await Promise.all([
          post(GET_DT_BALANCE_ENERGY, {
            BALANCE_DATE: moment(dateSelect).format("YYYY-MM-DD"),
          }),
          post(GET_DT_BALANCE_ZONE_ENERGY, {
            START_DATE: moment(props.dateSelected)
              .startOf("month")
              .format("YYYY-MM-DD"),
            END_DATE: moment(props.dateSelected)
              .endOf("month")
              .format("YYYY-MM-DD"),
          }),
          post(GET_DT_BALANCE_ENERGY, {
            BALANCE_DATE: moment(props.dateSelected)
              .startOf("month")
              .format("YYYY-MM-DD"),
            BALANCE_TO_DATE: moment(props.dateSelected)
              .endOf("month")
              .format("YYYY-MM-DD"),
          }),
        ]);

      let mapData = BALANCE_ZONE_ENERGY.data.dtBalanceList.map(
        objZoneEnergy => {
          let obj = BALANCE_ENERGY_ALL.data.dtBalanceList.find(
            objBalanceEnergy =>
              objBalanceEnergy.PID == objZoneEnergy.BALANCEENERGY_PID
          );
          if (obj) {
            objZoneEnergy.BALANCESHIPPER_PID = obj.BALANCESHIPPER_PID;
            objZoneEnergy.BALANCECOLUMN_PID = obj.BALANCECOLUMN_PID;
            objZoneEnergy.BALANCE_DAY = obj.BALANCE_DAY;
          }

          return objZoneEnergy;
        }
      );
      setMergeData(mapData);

      let tempBalaneEnergy = [];
      let tempDataList = [];
      let date = moment(dateSelect);
      balanceShipper.map((objShipper, index) => {
        let data = { row: index, SHIPPER_NAME: objShipper.SHIPPER_NAME };
        props.column.map(objColumn => {
          let createdBalaneEnergy = BALANCE_ENERGY.data.dtBalanceList.find(
            row =>
              row.BALANCESHIPPER_PID == objShipper.PID &&
              row.BALANCECOLUMN_PID == objColumn.PID &&
              row.BALANCE_DAY == date.format("D")
          );
          // console.log(createdBalaneEnergy)
          data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")] = {
            PID: "",
            BALANCE_DATE: date.format("YYYY-MM-DD"),
            BALANCESHIPPER_PID: objShipper.PID,
            BALANCECOLUMN_PID: objColumn.PID,
            BALANCECOLUMN_ORDER: objColumn.BALANCECOLUMN_ORDER,
            BALANCECOLUMN_NAME: objColumn.BALANCECOLUMN_NAME,
            BALANCE_DAY: date.format("D"),
            ...createdBalaneEnergy,
          };
          tempBalaneEnergy.push(
            data[`data_${objColumn.BALANCECOLUMN_NAME}`.replaceAll(".", "_")]
          );
          props.zone.map(objZone => {
            // console.log(createdBalaneEnergy, BALANCE_ZONE_ENERGY.data.dtBalanceList)
            let createdBalaneZoneEnergy =
              BALANCE_ZONE_ENERGY.data.dtBalanceList.find(
                row =>
                  row.BALANCEZONE_PID == objZone.PID &&
                  row.BALANCEENERGY_PID ==
                    (createdBalaneEnergy ? createdBalaneEnergy.PID : false)
              );
            // console.log(createdBalaneZoneEnergy)

            // console.log(createdBalaneZoneEnergy)
            data[
              `data_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                ".",
                "_"
              )
            ] = {
              BALANCEENERGY_PID: createdBalaneEnergy
                ? createdBalaneEnergy.PID
                : "",
              BALANCE_DATE: date.format("YYYY-MM-DD"),
              BALANCESHIPPER_PID: objShipper.PID,
              BALANCECOLUMN_PID: objColumn.PID,
              BALANCECOLUMN_ORDER: objColumn.BALANCECOLUMN_ORDER,
              BALANCECOLUMN_NAME: objColumn.BALANCECOLUMN_NAME,
              BALANCE_DAY: date.format("D"),
              PID: "",
              BALANCEZONE_PID: objZone.PID,
              BALANCEZONE_ORDER: objZone.BALANCEZONE_ORDER,
              BALANCEZONE_NAME: objZone.BALANCEZONE_ALIAS,
              BALANCE_DATA: "",
              ...createdBalaneZoneEnergy,
            };
            data[
              `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                ".",
                "_"
              )
            ] = createdBalaneZoneEnergy
              ? createdBalaneZoneEnergy.BALANCE_DATA
              : 0;
          });
        });
        tempDataList.push(data);
      });
      // console.log(tempBalaneEnergy)
      tempBalaneEnergy = tempBalaneEnergy.filter(row => row.PID == "");
      // console.log(tempBalaneEnergy)
      if (tempBalaneEnergy.length > 0) {
        if(permission.eBSG ){
          let res = await post(SAVE_DT_BALANCE_ENERGY, tempBalaneEnergy);
       
        
        generateRow();
        }
      }

      setModelDeviceList(tempDataList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
    // console.log(dataList)
  };

  // useEffect(() => {
  //  if(balaneEnergy.length>0 ||balaneZoneEnergy.length>0){
  //    console.log(1)
  //   generateRow();
  //  }

  // }, [balaneEnergy]);

  const formatNumber = (cellContent, row) => {
    return <>{numberFormat(cellContent, 2)}</>;
  };

  const getBalanceShipper = () =>
    post(GET_SHIPPER_BY_BOOKING, {
      LOAD_DATE: moment(dateSelect).format("YYYY-MM-DD"),
    });
  useEffect(() => {
    moment(props.dateSelected).isSame(new Date(), "month")
      ? setDateSelect(moment().add("days", -1).toDate())
      : setDateSelect(moment(props.dateSelected).endOf("month").toDate());
    // setDateSelect()
    addHeaderTable();
  }, [props.dateSelected]);
  useEffect(() => {
    getBalanceShipperData();
  }, [dateSelect]);
  useEffect(() => {
    renderColumn();
  }, [props.zone, props.column]);
  useEffect(() => {
    generateRow();
  }, [balanceShipper]);
  useEffect(() => {
    addHeaderTable();
    if (columnRenderList.length > 1) {
      // console.log(2)
      getBalanceShipperData();
    }
  }, [columnRenderList]);
  const renderColumn = () => {
    let addColumn = [
      ...props.column
        .sort((a, b) =>
          a.BALANCECOLUMN_ORDER > b.BALANCECOLUMN_ORDER
            ? 1
            : b.BALANCECOLUMN_ORDER > a.BALANCECOLUMN_ORDER
            ? -1
            : 0
        )
        .filter(
          obj =>
            obj.BALANCECOLUMN_SHOW == true || obj.BALANCECOLUMN_SHOW == "true"
        )
        .map(objColumn => {
          return props.zone
            .sort((a, b) =>
              a.BALANCEZONE_ORDER > b.BALANCEZONE_ORDER
                ? 1
                : b.BALANCEZONE_ORDER > a.BALANCEZONE_ORDER
                ? -1
                : 0
            )
            .map(objZone => ({
              dataField:
                `value_${objColumn.BALANCECOLUMN_NAME}_${objZone.BALANCEZONE_ALIAS}`.replaceAll(
                  ".",
                  "_"
                ),
              text: objZone.BALANCEZONE_ALIAS,
              headerAlign: "center",
              editable: true,
              align: "center",
              formatter: formatNumber,
              headerStyle: {
                backgroundColor: colorOption[2].label,
                fontSize: "10px",
                width: "20px",
              },
              style: { width: "25px", cursor: "pointer" },
              editorStyle: () => {
                return { height: "25px" };
              },
              classes: (cell, row, rowIndex, colIndex) => {
                let className = "";
                if (objColumn.STATUS_FLAG != 0) className += "from-source";
                if (objColumn.STATUS_FLAG == 1) className += " pmis";
                if (objColumn.STATUS_FLAG == 3) className += " gqms";
                return className;
              },
              validator: (newValue, row, column, done) => {
                setTimeout(() => {
                  if (isNaN(newValue)) {
                    return done({
                      valid: false,
                      message: "Should be numeric",
                    });
                  }
                  return done();
                }, 0);
                return {
                  async: true,
                };
              },
            }));
        }),
    ];
    let data = [];
    addColumn.map(array => {
      array.map(obj => data.push(obj));
    });
    // console.log(data)
    setColumnRenderList([
      {
        dataField: "SHIPPER_NAME",
        text: "",
        headerAlign: "center",

        align: "center",
        headerStyle: {
          backgroundColor: "#556ee6",
          fontSize: "12px",
          width: "20px",
        },
        style: { width: "20px" },
      },
      ...data,
      //   {
      //     dataField: "Action",
      //     text: "Action",
      //     headerAlign: "center",
      //     editable: false,
      //     align: "center",
      //     headerStyle: {
      //       backgroundColor: "#556ee6",
      //       width: "10%"
      //     },
      //     style: { width: "10%" },
      //     isDummyField: true,
      //     formatter: ButtonAction,
      //   },
    ]);
  };

  return (
    <>
      <Col sm="12">
        <div className="d-flex justify-content-end mb-2">
          <h5>Balancing & Shrinkgate Gas Data (Energy)</h5>
        </div>
        <div>
          <Row>
            <Col sm="5">
              <div style={{ width: "150px" }}>
                <Flatpickr
                  className="form-control d-block custom-date-picker"
                  placeholder="Select Date"
                  options={{
                    altInput: true,
                    altFormat: "d/m/Y",
                    // altFormat: "F Y",
                    dateFormat: "d/m/Y",
                    maxDate: moment(props.dateSelected).isSame(
                      new Date(),
                      "month"
                    )
                      ? moment().add("days", -1).toDate()
                      : moment(props.dateSelected).endOf("month").toDate(),
                    minDate: moment(props.dateSelected)
                      .startOf("month")
                      .toDate(),
                  }}
                  onChange={value => {
                    setDateSelect(value[0]);
                  }}
                  value={dateSelect}
                />
              </div>
            </Col>
            <Col
              sm="7"
              className="d-flex align-items-center justify-content-end"
            >
              {permission.eBSG && (
                <>
                  <button
                    type="button"
                    className="btn btn-info"
                    // onClick={manualRefresh}
                    onClick={() => {
                      dispatch(
                        confirmAction.showConfirm(
                          "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                          () => {
                            manualRefresh();
                          }
                        )
                      );
                    }}
                  >
                    <i className="mdi mdi-cloud-refresh fa-lg"></i>&nbsp;
                    Refresh Manual
                  </button>

                  <button
                    type="button"
                    className="btn btn-success ms-2"
                    onClick={handleSaveData}
                  >
                    <i className="bx bx-save"></i>&nbsp; Save
                  </button>
                </>
              )}
            </Col>
          </Row>
        </div>

        <>
          <div className="mt-2">
            <BootstrapTable
              id="balancingenergy-table"
              keyField="SHIPPER_NAME"
              data={modelDeviceList}
              columns={columnRenderList}
              headerClasses="header-style"
              rowStyle={rowStyle}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                onStartEdit: (oldValue, newValue, row, column) => {
                  $(
                    "#balancingenergy-table .form-control.editor.edit-text"
                  ).bind("enterKey", function (e) {
                    let cell = $(this).parent().next();
                    setTimeout(() => {
                      cell.click();
                    }, 50);
                  });
                  $(
                    "#balancingenergy-table .form-control.editor.edit-text"
                  ).keypress(function (e) {
                    if (e.keyCode == 13) {
                      $(this).trigger("enterKey");
                    }
                  });
                },
                afterSaveCell: (oldValue, newValue, row, column) => {
                  // console.log(oldValue,newValue, row, column)
                },
              })}
            />
          </div>

          <hr />
        </>
      </Col>

      {balanceShipper.map(item => (
        <TableEnergy
          key={item.PID}
          data={mergeData.filter(row => row.BALANCESHIPPER_PID == item.PID)}
          dateSelected={props.dateSelected}
          column={props.column}
          zone={props.zone}
          shipper={item}
        />
      ))}
    </>
  );
}
const rowStyle = (row, rowIndex) => {
  const style = {};

  style.color = "white";

  return style;
};

export default BalancingEnergy;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);

BalancingEnergy.propTypes = {
  dateSelected: PropTypes.any,
  column: PropTypes.any,
  zone: PropTypes.any,
  shipper: PropTypes.any,
};
